import EditIcon from "@material-ui/icons/Edit";
import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useGetAllDesignationsQuery,
  useModifyPersonnelAssessmentMutation,
} from "../../services/appln";

interface FormData {
  designationId: string;
  count: string;
}

interface Props {
  bandobastId: string;
  timeslotId: string;
  locationId: string;
  initialValues: any;
}

export default function EditPersonnelAssessment(props: Props) {
  console.log("EditPersonnelAssessment, props:", props);

  const [modifyPersonnelAssessment, modifyPersonnelAssessmentParams] =
    useModifyPersonnelAssessmentMutation();

  const designationData = useGetAllDesignationsQuery({
    page: 1,
    limt: 1000,
    search: "",
  });
  const designationMap = new Map<string, string>();
  designationData.data?.data.forEach((element: any) => {
    designationMap.set(element.name, element.id);
  });

  const initialValues: FormData = {
    designationId: props.initialValues.designationName,
    count: props.initialValues.count,
  };

  const [dialogOpen, setDialogOpen] = React.useState(false);

  console.log(
    "EditPersonnelAssessment, modifyPersonnelAssessmentParams:",
    modifyPersonnelAssessmentParams,
  );
  React.useEffect(() => {
    if (modifyPersonnelAssessmentParams.isSuccess) {
      setDialogOpen(false);
    }
  }, [modifyPersonnelAssessmentParams]);

  return (
    <div>
      <IconButton
        color="secondary"
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        <EditIcon />
      </IconButton>
      <Dialog
        open={dialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.editPersonnelAssessment}
        </DialogTitle>
        {modifyPersonnelAssessmentParams.isError && (
          <ErrorMsg msg={strings.failedToEditPersonnelAssessment} />
        )}
        {modifyPersonnelAssessmentParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.designationId) {
                errors.designationId = strings.designationMandatory;
              }
              if (!values.count) {
                errors.count = strings.countMandatory;
              } else {
                const countVal = parseInt(values.count);
                if (isNaN(countVal)) {
                  errors.count = strings.countShouldBeNumber;
                }
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const valuesClone = { ...values };
              valuesClone.designationId = designationMap.get(
                values.designationId!,
              )!;
              console.log(
                "EditPersonnelAssessment, values after modification",
                valuesClone,
              );
              setSubmitting(false);
              modifyPersonnelAssessment({
                bandobastId: props.bandobastId,
                timeslotId: props.timeslotId,
                locationId: props.locationId,
                personnelAssessmentId: props.initialValues.key,
                body: valuesClone,
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="designationId"
                        defaultValue={values.designationId}
                        options={Array.from(designationMap.keys())}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            margin="normal"
                            label={strings.designation}
                          />
                        )}
                        onChange={(e, value: any) => {
                          setFieldValue("designationId", value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="count"
                        name="count"
                        label={strings.count}
                        value={values.count}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.count && Boolean(errors.count)}
                        helperText={touched.count && errors.count}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.save}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            modifyPersonnelAssessmentParams.reset();
                            setDialogOpen(false);
                          }}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
